@if (header) {
  <h2>{{ header }}</h2>
}

@if (!data() || !groups()) {
  <!-- Display loading spinner -->
  <div class="centered" style="height: 50px">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else {
    <lib-table-vertical-control-core
      [groups]="groups()"
      [showImports]="showImports()"
      (cellChanged)="onCellChange($event)"
      (updateTable)="onUpdateTable()"
      (selectionDataChange)="onSelectionDataChange($event)"
    />
  }
